import React from 'react';

import Header from 'components/AppBar';
import Loader from 'components/Loader';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { AirlineResponse } from 'models/airlineException';
import AirlinesList from 'screens/containers/AirlinesList';

import ListView from './components/list';
import { Container, Content, Body, Info, Divider, Button } from './styles';

interface Props {
  airlines: AirlineResponse[];
  isLoading: boolean;
  show: boolean;
  companyId: string;
  onShow: () => void;
  onReturn: () => void;
  onDelete: (airlineId: string) => void;
  onSaveExcluded: () => void;
}

const AirlineException = ({
  airlines,
  isLoading,
  show,
  companyId,
  onShow,
  onReturn,
  onDelete,
  onSaveExcluded,
}: Props) => {
  const { t } = useStoreTranslation();
  const excludeAirlines = airlines.map((airline) => airline.code);

  return (
    <Container>
      <Desktop>
        <ScreenHeader title={t('airlineException.title')} />
      </Desktop>

      <Mobile>
        <Header goBack={onReturn}>{t('airlineException.title')}</Header>
      </Mobile>

      {isLoading ? (
        <Loader fullScreen />
      ) : (
        <Content>
          <Body>
            <Info>{t('airlineException.info')}</Info>
            <Divider />
            <Button onClick={onShow}>{t('airlineException.button')}</Button>
          </Body>
          <ListView airlines={airlines} onDelete={onDelete} />
          <AirlinesList
            show={show}
            close={onShow}
            companyId={companyId}
            excludeAirlines={excludeAirlines}
            onSaveCallBack={onSaveExcluded}
          />
        </Content>
      )}
    </Container>
  );
};

export default AirlineException;
